import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

class InteractionApiService extends BaseApiService {
    /**
     * Crea uns instancia de @see InteractionApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'interaction', 'Interaction');
    }
    /***
      * Metodo encargado de almacenar la interaccion cuando es consumido por una aplicación externa
      * @param data Objeto con la cadena de payload de la información a insertar
      * @param args Argumentos extra para la consulta de información
      * @returns Returns una cadena del objeto con la información @see DataExternalDto
      */
    postExternal(data, args) {
        return this.getUri(uri => this.httpClient.post(`${uri}/PostExternal`, data));
    }
}
InteractionApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: InteractionApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
InteractionApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: InteractionApiService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: InteractionApiService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

class SettingApiService extends BaseApiService {
    /**
     * Crea uns instancia de @see SettingApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'interaction', 'Setting');
    }
}
SettingApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SettingApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
SettingApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SettingApiService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SettingApiService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of interaction
 */
//export * from './lib/models/payload-scheduling/payload-scheduling.interface';
//export * from './lib/models/payload-scheduling/cancelation/cancelation.interface';
//export * from './lib/models/payload-scheduling/channel/channel.interface';
//export * from './lib/models/payload-scheduling/contact/contact.interface';
//export * from './lib/models/payload-scheduling/contact/additional-information/additional-information.interface';
//export * from './lib/models/payload-scheduling/contact/additional-information/active-product/product-data.interface';
//export * from './lib/models/payload-scheduling/contact/additional-information/information-family/information-family.interface';
//export * from './lib/models/payload-scheduling/contact/additional-information/segment/segment.interface';
//export * from './lib/models/payload-scheduling/contact/city-contact/city-contact.interface';
//export * from './lib/models/payload-scheduling/contact/type-contact/type-contact.interface';
//export * from './lib/models/payload-scheduling/contact/type-document/type-document.interface';
//export * from './lib/models/payload-scheduling/gestion/gestion.interface';
//export * from './lib/models/payload-scheduling/office/office.interface';
//export * from './lib/models/payload-scheduling/preparation/preparation.interface';
//export * from './lib/models/payload-scheduling/state-scheduling/state-scheduling.interface';
//export * from './lib/models/payload-scheduling/typify/typify.interface';
//export * from './lib/models/payload-scheduling/typify/metadata-typify/metadata-typify.interface';
//export * from './lib/models/payload-scheduling/typify/metadata-typify/structure-form/structure-form.interface';
//export * from './lib/models/payload-scheduling/typify/metadata-typify/structure-form/form/form.interface';
//export * from './lib/models/payload-scheduling/typify/metadata-typify/structure-form/form/field/field.interface';
//export * from './lib/models/payload-scheduling/user/user.interface';

/**
 * Generated bundle index. Do not edit.
 */

export { InteractionApiService, SettingApiService };
